export enum SubscriptionState {
    Initial,
    SubscriptionFailed,
    SuccessfulRegistration,
}
